import { put, select, takeLatest } from 'redux-saga/effects'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { saveTimelineItems, setActivityLog } from '../store/timeline.actions'
import { TimelineConstants } from '../store/timeline.constants'
import { IItem, ITimelineState } from '../store/timeline.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IAssessmentState } from '../../procedures/assessment/store/assessment.types'
import { getAssessmentSelector } from '../../procedures/assessment/selectors'

export function* addAssessmentItem() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { items } = timeline
  const assessmentState: IAssessmentState = yield select(getAssessmentSelector)
  const { pta, addToTimeline, key, time, date, assessedBy, action, comments } = assessmentState
  try {
    if (addToTimeline) {
      const assessedByLabel = assessedBy?.name || ''
      const index = items.findIndex((item) => item.key === key)
      const dateTime = new Date(date || 0)
      if (time) {
        if (time.split(':').length >= 3) dateTime.setSeconds(+time.split(':')[2])
        dateTime.setMinutes(+time.split(':')[1])
        dateTime.setHours(+time.split(':')[0])
      }
      const item: IItem = {
        key: key,
        grid: true,
        labelHeaderFlag: pta ? 'PTA' : '',
        labelHeader: time,
        subHeader: date,
        itemType: 'Procedures',
        event: TimelineConstants.ASSESSMENT,
        eventSubHeader: `By ${assessedByLabel}, Action: ${action?.name || ''} Comments: ${comments}.`,
        rowActionType: TimelineConstants.SET_ASSESSMENT,
        defaultHref: TabConstants.ASSESSMENT_PROCEDURE,
        date: dateTime,
      }
      if (index !== -1) {
        items[index] = item
      } else {
        items.push(item)
      }
      yield put(setActivityLog(items))
      yield put(saveTimelineItems())
    }
  } catch (e) {
    yield put(throwPcrException(`addAssessmentItemSaga() error: ${e}`))
  }
}
export function* addAssessmentItemSaga() {
  yield takeLatest([TimelineConstants.ADD_ASSESSMENT], performWithMutexHOG, addAssessmentItem)
}
